import type { NewEndpointResource, StepPackageEndpointResource } from "@octopusdeploy/octopus-server-client";
export function IsStepPackageEndpoint(endpoint: NewEndpointResource): endpoint is StepPackageEndpointResource {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
    return (endpoint as StepPackageEndpointResource).DeploymentTargetTypeId !== undefined;
}
